import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

 import { AsyncSubject } from 'rxjs';

import { BaseSegmentComponent } from '../base/_base-segment.component';
import { FitmentsTableComponent } from 'shared/fitments/fitments-table/fitments-table.component';
import { ProductDetailsService } from '../../product-details.service';
import { ProductPanelService } from '../../../product-panel/product-panel.service';
import { ScrollToService } from 'shared/base/scroll-to.service';
import { pageOptions } from '../../product-details-options';
import { advancedSearchRouteMap } from 'shared/search/search-helpers';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { indexPagesData } from 'utils/index-pages-data';
import {first} from 'rxjs/operators';

@Component({
  moduleId: module.id,
  selector: 'fitments-segment',
  templateUrl: 'fitments.component.html',
  styleUrls: ['fitments.component.scss'],
  providers: [ScrollToService],
})
export class FitmentsComponent extends BaseSegmentComponent implements OnInit, AfterViewInit {

  headers: Array<string> = ['year', 'make', 'model', 'sub_model'];
  permissions: Array<string> = ['admin', 'fitments'];

  itemId: number;
  advancedSearchStatus: string;
  itemsPerPage: number = 10;
  ghostValue: string = 'detail-08';
  dataLoaded: AsyncSubject<any> = new AsyncSubject<any>();
  // to hide search input if there no fitments at the beginning
  hasSearch: boolean = true;

  @Input() itemStatus: number;
  @Input() productId: any;

  @ViewChild(FitmentsTableComponent, {static: true})
  fitmentsTable: FitmentsTableComponent | void;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected productDetailsService: ProductDetailsService,
    protected productPanelService: ProductPanelService,
    private scrollToService: ScrollToService,
    protected permissionsService: PermissionsService,
  ) {
    super(productDetailsService, productPanelService, permissionsService);
  }

  ngOnInit() {
    // subscribe to initial data loading for correct scrolling to segment
    if (this.fitmentsTable instanceof FitmentsTableComponent) {
      this.fitmentsTable.dataFetched
        .pipe(first())
        .subscribe((data: any) => {
          // if there is no data at the beginning then hide advanced search
          if (!data || !data.data.length) {
            this.hasSearch = false;
          }
          this.dataLoaded.next(data);
          this.dataLoaded.complete();
        });
    }
    const { id } = this.route.snapshot.params;
    this.itemId = id;
    this.data = this.orderBy(this.data, 'sequence');
    this.scrollToService.init({
      pageScrollOffset: pageOptions.headerMinHeight - pageOptions.segmentItemOffsets,
    });
    this.advancedSearchStatus = advancedSearchRouteMap[this.getRoute()];
  }

  ngAfterViewInit() {
    // for allowing scroll after fething and rendering data only
    this.dataLoaded
    .pipe(first())
    .subscribe(null, null, () => {
      super.ngAfterViewInit();
    });
  }

  onPageChange(page: any) {
    this.scrollToService.scrollTo({
      scrollTarget: '#fitmentsHeader'
    });
  }

  onEditButtonClick(segmentName: string) {
    const { id } = this.route.snapshot.params;
    this.router.navigate([`/fitments/${id}`]);
  }

  public fetchFitments() {
    if (this.fitmentsTable instanceof FitmentsTableComponent) {
      this.fitmentsTable.runSearch();
    }
  }

  private getRoute() {
      return _.head( _.keys(
        _.pickBy(indexPagesData, (value, key) => {
          return value.itemStatuses.indexOf(this.itemStatus) > -1;
        })
      ));
  }
}
